module.exports = __webpack_public_path__ + "img/tag-programming.0ba149a3.svg";